import {
  ISelectorChooser,
  ISelectorOption,
} from "@/components/excel/schema/definiens/selector";

export const RMBOption: ISelectorOption = {
  value: 1,
  text: "人民币",
};
export const DollarOption: ISelectorOption = {
  value: 2,
  text: "美元",
};
export const EuroOption: ISelectorOption = {
  value: 3,
  text: "欧元",
};
export const PoundOption: ISelectorOption = {
  value: 4,
  text: "英镑",
};
export const CurrencySelector: ISelectorChooser = {
  default: RMBOption.value,
  options: [RMBOption, DollarOption, EuroOption, PoundOption],
};
